import * as React from 'react'
import './index.scss'
import {connect} from "react-redux";
import {ActionType, CHAINTYPES, reducerStoreType, merchantInfoType} from "../../reducers/types";
import {Dispatch} from "redux";
import ApplyForm from "./ApplyForm";
import noDataIcon from '../../images/null_icon.svg';
import {injectIntl, IntlShape} from 'react-intl';

interface IProps {
    dispatch: Dispatch<ActionType<undefined>>,
    chainType: CHAINTYPES,
	merchantInfo: merchantInfoType,
	intl: IntlShape
}

class ExchangeApply extends React.Component<IProps, {}> {
    public render() {
		let {merchantInfo,intl} = this.props
        return (		 
			<div className="exchangeManage">
				{ merchantInfo.exchangeWithdrawFlag === 1 ? 
					<div className="exchangeInfo">
						<ApplyForm/>
					</div>
					: <div className="noData">
					    <img src={noDataIcon} alt="no function"/>
					    <p>{intl.formatMessage({id: 'functionToast'})}</p>
					</div>
				}
			</div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        chainType: state.merchant.merchantInfo.chainType,
        merchantInfo: state.merchant.merchantInfo
    }
})(ExchangeApply))